




































import {Component, Mixins} from 'vue-mixin-decorator';
import {getModule} from 'vuex-module-decorators';

import {DateTime} from '@/utils/DateTime';

import SystemInfoStore from '@/store/system/SystemInfo.store';

import Widget from '@/components/Utils/Widget.vue';

import {BaseComponent} from '@/mixins/BaseComponent';
import SystemRegionStore from '@/store/system/SystemRegion.store';

@Component({
  components: {Widget},
})
export default class SystemInfoWidget extends Mixins<BaseComponent>(BaseComponent) {

  private DateTime = DateTime;

  private systemInfoStore: SystemInfoStore = getModule(SystemInfoStore, this.$store);

  private systemRegionStore: SystemRegionStore = getModule(SystemRegionStore, this.$store);

  private dateTimeOptions: Intl.DateTimeFormatOptions = {};

  get locale() {
    return navigator.language;
  }

  private async mounted() {
    this.setLoading();
    try {
      await this.systemInfoStore.fetchSystemInfo();
      await this.systemRegionStore.fetchDatetime();
      await this.systemInfoStore.fetchHardwareInfo();
    } finally {
      this.setLoaded();
    }
  }
}
